module.exports = __webpack_public_path__ + "img/_Logo.c517fb67.jpeg";